const initialState = {
  prompts: [],
  promptsLoading: false,
  // Prompt de base (lecture seule) et apercu du prompt final, fournis par l'API
  // pour que l'administrateur voie exactement ce qui part au modele.
  basePrompt: "",
  promptPreview: "",

  documents: [],
  documentsLoading: false,
  uploading: false,
  reindexing: false,
  corpusStatus: null,

  discussions: [],
  discussionsLoading: false,
  openedDiscussionId: null,
  messages: [],
  messagesLoading: false,

  stats: null,
  error: null,
};

const iaAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ------------------------------- Prompts ------------------------------ */
    case "IA_ADMIN_PROMPTS_LOADING":
      return { ...state, promptsLoading: true };
    case "IA_ADMIN_PROMPTS_SUCCESS":
      return {
        ...state,
        promptsLoading: false,
        prompts: action.payload.prompts,
        basePrompt: action.payload.meta?.basePrompt || state.basePrompt,
        promptPreview: action.payload.meta?.preview || "",
      };
    case "IA_ADMIN_PROMPTS_FAIL":
      return { ...state, promptsLoading: false, error: action.payload };

    /* ------------------------------ Documents ----------------------------- */
    case "IA_ADMIN_DOCUMENTS_LOADING":
      return { ...state, documentsLoading: true };
    case "IA_ADMIN_DOCUMENTS_SUCCESS":
      return { ...state, documentsLoading: false, documents: action.payload };
    case "IA_ADMIN_DOCUMENTS_FAIL":
      return { ...state, documentsLoading: false, error: action.payload };

    case "IA_ADMIN_UPLOADING":
      return { ...state, uploading: action.payload };
    case "IA_ADMIN_REINDEXING":
      return { ...state, reindexing: action.payload };

    case "IA_ADMIN_STATUS_SUCCESS":
      return { ...state, corpusStatus: action.payload };
    case "IA_ADMIN_STATUS_FAIL":
      return { ...state, error: action.payload };

    /* ---------------------------- Conversations --------------------------- */
    case "IA_ADMIN_DISCUSSIONS_LOADING":
      return { ...state, discussionsLoading: true };
    case "IA_ADMIN_DISCUSSIONS_SUCCESS":
      return { ...state, discussionsLoading: false, discussions: action.payload };
    case "IA_ADMIN_DISCUSSIONS_FAIL":
      return { ...state, discussionsLoading: false, error: action.payload };

    case "IA_ADMIN_MESSAGES_LOADING":
      return { ...state, messagesLoading: true, openedDiscussionId: action.payload };
    case "IA_ADMIN_MESSAGES_SUCCESS":
      return {
        ...state,
        messagesLoading: false,
        openedDiscussionId: action.payload.discussionId,
        messages: action.payload.messages,
      };
    case "IA_ADMIN_MESSAGES_FAIL":
      return { ...state, messagesLoading: false, error: action.payload };
    case "IA_ADMIN_MESSAGES_CLOSE":
      return { ...state, openedDiscussionId: null, messages: [] };

    case "IA_ADMIN_STATS_SUCCESS":
      return { ...state, stats: action.payload };
    case "IA_ADMIN_STATS_FAIL":
      return { ...state, error: action.payload };

    case "LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default iaAdminReducer;
